// extracted by mini-css-extract-plugin
module.exports = {"maintenance":"styles_maintenance__1zmWZ","offline":"styles_offline__2H25_","error":"styles_error__gDcx4","settingsLink":"styles_settingsLink__3BN8R"};